import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';

Vue.use(Router);



/* Layout */
// import Layout from '@/layout'

/* Router Modules */
// import componentsRouter from './modules/components'
// import chartsRouter from './modules/charts'
// import tableRouter from './modules/table'
// import nestedRouter from './modules/nested'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [{
        path: '/',
        name: 'index',
        component: () =>
            import ('@/views/index/index'),
        meta: {
            title: "首页"
        }
    },
    {
        path: '/maps',
        component: () =>
            import ('@/views/index/maps'),
        meta: {
            title: 'maps'
        }
    },
    {
        path: '/login/index',
        redirect: '/login/mobile',
        component: () =>
            import ('@/views/login/login'),
        meta: {
            title: 'login'
        },
        children: [{
                path: '/login/account',
                component: () =>
                    import ('@/views/login/account'),
                meta: {
                    title: 'login',
                    forbidLogin: true
                }
            },
            {
                path: '/login/mobile',
                component: () =>
                    import ('@/views/login/mobile'),
                meta: {
                    title: 'login',
                    forbidLogin: true
                }
            }
        ]
    }, {
        path: '/login/find',
        component: () =>
            import ('@/views/login/find'),
        meta: {
            title: 'find',
            forbidLogin: true
        }
    }, {
        path: '/login/register',
        component: () =>
            import ('@/views/login/register'),
        meta: {
            title: 'register',
            forbidLogin: true
        }
    },
    {
        path: '/message/notice',
        component: () =>
            import ('@/views/message/notice'),
        meta: {
            title: 'notice'
        }
    },
    {
        path: '/message/notice/:id',
        component: () =>
            import ('@/views/message/info'),
        meta: {
            title: 'notice'
        }
    },
    {
        path: '/message/consult/index',
        component: () =>
            import ('@/views/message/consultList'),
        meta: {
            title: 'consult'
        }
    },
    {
        path: '/message/consult',
        component: () =>
            import ('@/views/message/consult'),
        meta: {
            title: 'consult'
        }
    },
    {
        path: '/user/company',
        component: () =>
            import ('@/views/user/company'),
        meta: {
            title: 'user',
            needLogin: true
        }
    },
    {
        path: '/user/gov',
        redirect: '/user/gov/urgentList',
        component: () =>
            import ('@/views/user/gov'),
        meta: {
            title: 'user',
            needLogin: true
        },
        children: [{
                path: '/user/gov/urgentList',
                component: () =>
                    import ('@/views/user/urgentList'),
                meta: {
                    title: 'user',
                    needLogin: true,
                    govTab: 'list'
                }
            },
            {
                path: '/user/gov/urgentList/edit/:id',
                component: () =>
                    import ('@/views/user/listEdit'),
                meta: {
                    title: 'user',
                    needLogin: true,
                    govTab: 'list'
                }
            },
            {
                path: '/user/gov/urgentreview',
                component: () =>
                    import ('@/views/user/urgentreview'),
                meta: {
                    title: 'user',
                    needLogin: true,
                    govTab: 'review'
                }
            },
            {
                path: '/user/gov/urgentreview/edit/:id',
                component: () =>
                    import ('@/views/user/reviewEdit'),
                meta: {
                    title: 'user',
                    needLogin: true,
                    govTab: 'review'
                }
            }
        ]
    },
    {
        path: '/user/news',
        component: () =>
            import ('@/views/user/news'),
        meta: {
            title: 'user'
        }
    },
    {
        path: '/station/edit',
        component: () =>
            import ('@/views/station/edit'),
        meta: {
            title: 'user'
        }
    },
    {
        path: '/station/edit/:id',
        component: () =>
            import ('@/views/station/edit'),
        meta: {
            title: 'user'
        }
    },
    {
        path: '/station/association',
        component: () =>
            import ('@/views/station/association'),
        meta: {
            title: 'user'
        }
    },
    {
        path: '/station/association/:id',
        component: () =>
            import ('@/views/station/association'),
        meta: {
            title: 'user'
        }
    }

];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */



export const asyncRoutes = [];



const createRouter = () => new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
});

const router = createRouter();

router.beforeEach((to, from, next) => {
    const token = store.getters.userinfo.token;
    console.log('each router', to);
    console.log('token', token);
    console.log('store', store.getters.userinfo);
    // if (token && (to.path === '/login/account' || to.path === '/login/mobile' || to.path === '/login/find' || to.path === '/login/register')) {
    //     // if (token) return
    //     return next(`'/user/'${store.getters.userinfo.role}`);
    // }
    if (to.meta.needLogin) {
        if (token) {
            return next();
        } else {
            return next('/login/mobile');
        }
    }
    if (to.meta.forbidLogin && token) {
        return next(`/user/${store.getters.userinfo.role}`);
    }
    next();
    // return next(token ? to.path : '/login/account');
    // if (!token) return next('/login/account')
})
console.log('router', router);



export default router